export default __webpack_public_path__ + "static/Alhambra_Palace_Granada_Spain-029778b1d4640c65e061de636ee1bbfc.jpg";